import PropTypes from 'prop-types'
import React from 'react'

const DeleteBtn = (props) => {
  /*44x31*/
  return (
    <span className="delete-svg-wrapper">
      <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 44 31"
        style={{ fill: props.fill }}
      >
        <title>Delete</title>
        <path
          fillOpacity={props.fillOpacity}
          fill={props.fill}
          fillRule="evenodd"
          d="M.579 16.42a1.923 1.923 0 0 1 .042-2.79L15.16 0v31L.579 16.42zM39.162 0c2.207 0 3.997 1.8 3.997 4.005v22.99A4.004 4.004 0 0 1 39.162 31H15.159V0h24.003zM26.159 14.586l-6.364-6.364-1.414 1.414L24.745 16l-6.364 6.364 1.414 1.414 6.364-6.364 6.364 6.364 1.414-1.414L27.573 16l6.364-6.364-1.414-1.414-6.364 6.364z"
        />
      </svg>
    </span>
  )
}

DeleteBtn.propTypes = {
  fill: PropTypes.string,
  fillOpacity: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export default DeleteBtn
